import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../../../../components/custom_table/CustomTable";
import "./SalesReport.css";
import {
  FormControl,
  Box,
  IconButton,
  Switch,
  useMediaQuery,
} from "@mui/material";
import CustomBottomPagination from "../../../../../components/custom_bottom_pagination/CustomBottomPagination";
import { ApiConfig } from "../../../../../api/apiConfig";
import { ErrorToast } from "../../../../../toast/toasts";
import { PiMicrosoftExcelLogoLight } from "react-icons/pi";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { get_locations_with_out_pagination } from "../../../../../api/locationApis";
import { get_services } from "../../../../../api/servicesApis";
import { get_tax_settings_lists } from "../../../../../api/generalSettingApis";
import CustomYearPicker from "../../../../../components/custom_year_picker/CustomYearPicker";
import CustomAutoCompleteDropdown from "../../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";
import { CommonHelpers } from "../../../../../services/commonHelpers";


const SalesReports = () => {
  const isCollapsed = useSelector((state) => state.commonStore.isCollapsed);
  const currentMonth = new Date().getMonth() + 1;
  const formattedMonth = String(currentMonth).padStart(2, "0");
  const currentYear = new Date().getFullYear();

  // ✅ State Management
  const [selectedOption, setSelectedOption] = useState("B2B");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItemPerPage, setTotalItemPerPage] = useState(25);
  const [reportList, setReportList] = useState([]);

  const [taxSettingValues, setTaxSettingValues] = useState(null);
  const [locations, setLocations] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [isFinancialYear, setIsFinancialYear] = useState(false);
  // const [margin, setMargin] = useState(0);

  const [totals, setTotals] = useState({
    total_las_margin: 0,
    
    TotalTaxableAmount: 0,
    TotalSupplierAmount: 0,
    TotalCGST: 0,
    TotalSGST: 0,
    TotalIGST: 0,
    TotalGST: 0,
    TotalInvoice: 0,
    TotalSales: 0,
    TotalRefund:0
  });

  // ✅ Unified Filter Payload
  const [filterPayload, setFilterPayload] = useState({
    month: formattedMonth,
    year: dayjs(`${currentYear}-01-01`),
    location_id: "All",
    service_id: 1,
    financial_year_start: CommonHelpers.getLastCompletedFinancialYear().start,
    financial_year_end: CommonHelpers.getLastCompletedFinancialYear().end,
    filter_type: "YEAR",
  });

  // ✅ Generate Financial Year List
  const financialYearOptions = CommonHelpers.getFinancialYearList(2023, 3).map(
    (fy) => ({
      label: fy.label,
      value: fy.value,
    })
  );

  // Get privileges details from local storage
  const getPrivilegesDetails = () =>
    JSON.parse(localStorage.getItem("privileges_details") || "[]");

  // Check if a specific privilege exists in User Management -> User
  const hasPrivilege = (privilegeName) =>
    getPrivilegesDetails().some(
      (item) =>
        item.module_name === "Reports" &&
        item.submodules?.["Sales"]?.privileges?.some(
          (priv) => priv.name === privilegeName
        )
    );
  const isSales_Download = hasPrivilege("Download");
  useEffect(() => {
    if (selectedOption === "B2B") getB2Breport();
    else getB2Creport();
  }, [pageNumber, totalItemPerPage, filterPayload, selectedOption]);

  useEffect(() => {
    getLocations();
    getServices();
    get_tax_settings_list();
  }, []);

  // ✅ API: Services
  const getServices = () => {
    get_services()
      .then((response) => {
        const data = response.map((item) => ({
          label: item.ES_services_name,
          value: item.ES_id,
        }));
        setServicesList(data);
      })
      .catch(console.error);
  };

  // ✅ API: Locations
  const getLocations = () => {
    get_locations_with_out_pagination()
      .then((response) => {
        const data = response?.data.map((item) => ({
          label: item.ld_name,
          value: item.ld_id,
        }));
        setLocations([{ label: "All", value: "All" }, ...data]);
      })
      .catch(console.error);
  };

  // ✅ API: Tax Settings
  const get_tax_settings_list = () => {
    get_tax_settings_lists()
      .then((response) => {
        if (response?.data?.code === 200 && response?.data?.data) {
          const { tax_rate, cgst, igst, sgst, tcs, tds } = response.data.data;
          setTaxSettingValues({ tax_rate, cgst, igst, sgst, tcs, tds });
        } else {
          ErrorToast(response?.data?.message);
        }
      })
      .catch(console.error);
  };
  //----------------FOR HANDLE PAGINATION START

  const [isLoading, setIsLoading] = useState(true);

  const getB2Breport = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("page", pageNumber);
    formData.append("pageItem_count", totalItemPerPage);

    Object.entries(filterPayload).forEach(([key, value]) => {
      if (key === "year" && value) {
        // If 'year' is a Dayjs or Date object → extract actual year
        const yearValue = value.year
          ? value.year()
          : new Date(value).getFullYear();
        formData.append(key, yearValue);
      } else if (key === "location_id") {
        // Replace "All" with empty string
        formData.append(key, value === "All" ? "" : value);
      } else {
        formData.append(key, value);
      }
    });
    await ApiConfig.post("/flightBookingReport_B2B", formData)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.data?.data) {
          setReportList(response?.data?.data?.data);
          setTotalPages(response?.data?.data?.last_page);
          // setMargin(response?.data?.total_las_margin); //CHANGED BY SREERAJ 31-10-25 FOR SHOW TOTAL MARIGN FOR THE B2B SALES
          setTotals({
            total_las_margin: response?.data?.total_las_margin ?? 0,
            TotalTaxableAmount: response?.data?.TotalTaxableAmount ?? 0,
            TotalSupplierAmount: response?.data?.TotalSupplierAmount ?? 0,

            TotalCGST: response?.data?.TotalCGST ?? 0,
            TotalSGST: response?.data?.TotalSGST ?? 0,
            TotalIGST: response?.data?.TotalIGST ?? 0,
            TotalGST: response?.data?.TotalGST ?? 0,

            TotalInvoice: response?.data?.TotalInvoice ?? 0,
            TotalSales: response?.data?.TotalSales ?? 0,
            TotalRefund:response?.data?.TotalRefund ?? 0
            
          });
        } else {
          setReportList([]);
          setTotalPages(0);
          ErrorToast(response?.data?.message);
        }
      })
      .catch((error) => {
        setReportList([]);
        setTotalPages(0);
        let message = "";
        for (const key in error?.data?.errors) {
          if (error?.data?.errors.hasOwnProperty(key)) {
            const keyMessages = error?.data?.errors[key].map(
              (message) => message
            );
            message = message.concat(keyMessages);
          }
        }
        ErrorToast(message);
      });
  };

  const getB2Creport = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("page", pageNumber);
    formData.append("pageItem_count", totalItemPerPage);
    Object.entries(filterPayload).forEach(([key, value]) => {
      if (key === "year" && value) {
        // If 'year' is a Dayjs or Date object → extract actual year
        const yearValue = value.year
          ? value.year()
          : new Date(value).getFullYear();
        formData.append(key, yearValue);
      } else if (key === "location_id") {
        // Replace "All" with empty string
        formData.append(key, value === "All" ? "" : value);
      } else {
        formData.append(key, value);
      }
    });

    await ApiConfig.post("/flightBookingReport_B2C", formData)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.data?.data) {
          setReportList(response?.data?.data?.data);
          setTotalPages(response?.data?.data?.last_page);
          // setMargin(response?.data?.total);
          setTotals({
            total_las_margin: response?.data?.total_las_margin ?? 0,
            TotalTaxableAmount: response?.data?.TotalTaxableAmount ?? 0,
            TotalSupplierAmount: response?.data?.TotalSupplierAmount ?? 0,

            TotalCGST: response?.data?.TotalCGST ?? 0,
            TotalSGST: response?.data?.TotalSGST ?? 0,
            TotalIGST: response?.data?.TotalIGST ?? 0,
            TotalGST: response?.data?.TotalGST ?? 0,

            TotalInvoice: response?.data?.TotalInvoice ?? 0,
            TotalSales: response?.data?.TotalSales ?? 0,
            TotalRefund:response?.data?.TotalRefund ?? 0
          });
        } else {
          // setMargin(0);
          setReportList([]);
          setTotalPages(0);
          ErrorToast(response?.data?.message);
        }
      })
      .catch((error) => {
        // setMargin(0);
        setReportList([]);
        setTotalPages(0);
        let message = "";
        for (const key in error?.data?.errors) {
          if (error?.data?.errors.hasOwnProperty(key)) {
            const keyMessages = error?.data?.errors[key].map(
              (message) => message
            );
            message = message.concat(keyMessages);
          }
        }
        ErrorToast(message);
      });
  };

  const Columns = [
    {
      title: "Sl.No",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Invoice Date",
      dataIndex: "Invoice_Date",
      key: "Invoice_Date",
    },
    {
      title: "Invoice No",
      dataIndex: "Invocie_No",
      key: "Invocie_No",
      action: (row) => (
        <p
          className="flight_ticket_additional_info_attachment_item"
          onClick={() => {
            if (row?.Invoice_Link) {
              CommonHelpers.DownloadAssets(row?.Invoice_Link);
            }
          }}
        >
          {row?.Invocie_No}
          {/* {console.log(row, "b2b")} */}
        </p>
      ),
    },
    {
      title: "Name of Client",
      dataIndex: "Name_of_Client",
      key: "Name_of_Client",
    },
    {
      title: "GSTIN No",
      dataIndex: "GSTIN_No",
      key: "GSTIN_No",
    },
    {
      title: "Service Details",
      dataIndex: "Service_Details",
      key: "Service_Details",
    },
    {
      title: "PNR #",
      dataIndex: "PNR_NO",
      key: "PNR_NO",
    },
    {
      title: "Taxable Amount",
      dataIndex: "Taxable_Amount",
      key: "Taxable_Amount",
    },
    {
      title: `GST Rate (${taxSettingValues?.tax_rate}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "GST_Rate",
      key: "GST_Rate",
    },
    {
      title: `CGST (${taxSettingValues?.cgst}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "CGST",
      key: "CGST",
    },
    {
      title: `SGST (${taxSettingValues?.sgst}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "SGST",
      key: "SGST",
    },
    {
      title: `IGST (${taxSettingValues?.igst}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "IGST",
      key: "IGST",
    },
    {
      title: "Total GST",
      dataIndex: "Total_GST",
      key: "Total_GST",
    },
    {
      title: `TDS (${taxSettingValues?.tds}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "TDS",
      key: "TDS",
    },
    {
      title: `TCS (${taxSettingValues?.tcs}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "TCS",
      key: "TCS",
    },
    {
      title: "Supplier Amount",
      dataIndex: "Supplier_Amount",
      key: "Supplier_Amount",
    },
    {
      title: "Agent Commision",
      dataIndex: "Agent_Commision",
      key: "Agent_Commision",
    },
    {
      title: "Commission provided by supplier",
      dataIndex: "commisson_from_supplier",
      key: "commisson_from_supplier",
    },
    {
      title: "GST",
      dataIndex: "GST",
      key: "GST",
    },
    {
      title: "TDS Deducted",
      dataIndex: "TDS_deducted",
      key: "TDS_deducted",
    },
    {
      title: "LAS Margin",
      dataIndex: "Las_Margin",
      key: "LastMargin",
    },
    {
      title: "Total Invoice Value",
      dataIndex: "Total_Invoice_value",
      key: "TotalInvoice_value",
    },
    {
      title: "Exempted",
      dataIndex: "Exempted",
      key: "Exempted",
    },
    {
      title: "Refund",
      dataIndex: "Refund",
      key: "Refund",
    },
    {
      title: "Total Sales",
      dataIndex: "Total_Sales",
      key: "Total_Sales",
    },
    {
      title: "Remarks",
      dataIndex: "Remarks",
      key: "Remarks",
    },
  ];

  const Columns_B2C = [
    {
      title: "Sl.No",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Invoice Date",
      dataIndex: "Invoice_Date",
      key: "Invoice_Date",
    },
    {
      title: "Invoice No",
      dataIndex: "Invocie_No",
      key: "Invocie_No",
      action: (row) => (
        <p
          className="flight_ticket_additional_info_attachment_item"
          onClick={() => {
            if (row?.Invoice_Link) {
              CommonHelpers.DownloadAssets(row?.Invoice_Link);
            }
          }}
        >
          {row?.Invocie_No}
          {/* {console.log(row, "b2c")} */}
        </p>
      ),
    },
    {
      title: "Name of Client",
      dataIndex: "Name_of_Client",
      key: "Name_of_Client",
    },
    {
      title: "GSTIN No",
      dataIndex: "GSTIN_No",
      key: "GSTIN_No",
    },
    {
      title: "Service Details",
      dataIndex: "Service_Details",
      key: "Service_Details",
    },
    {
      title: "PNR #",
      dataIndex: "PNR_NO",
      key: "PNR_NO",
    },
    {
      title: "Taxable Amount",
      dataIndex: "Taxable_Amount",
      key: "Taxable_Amount",
    },
    {
      title: `GST Rate (${taxSettingValues?.tax_rate}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "GST_Rate",
      key: "GST_Rate",
    },
    {
      title: `CGST (${taxSettingValues?.cgst}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "CGST",
      key: "CGST",
    },
    {
      title: `SGST (${taxSettingValues?.sgst}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "SGST",
      key: "SGST",
    },
    {
      title: `IGST (${taxSettingValues?.igst}%)`, // Logic added By Sajin (22-11-2024)
      dataIndex: "IGST",
      key: "IGST",
    },
    {
      title: "Total GST",
      dataIndex: "Total_GST",
      key: "Total_GST",
    },
    {
      title: `TDS (${taxSettingValues?.tds}%)`,
      dataIndex: "TDS",
      key: "TDS",
    },
    {
      title: `TCS (${taxSettingValues?.tcs}%)`,
      dataIndex: "TCS",
      key: "TCS",
    },
    {
      title: "Supplier Amount",
      dataIndex: "Supplier_Amount",
      key: "Supplier_Amount",
    },
    {
      title: "Agent Commision",
      dataIndex: "Agent_Commision",
      key: "Agent_Commision",
    },
    {
      title: "Commission provided by supplier",
      dataIndex: "commisson_from_supplier",
      key: "commisson_from_supplier",
    },
    {
      title: "GST",
      dataIndex: "GST",
      key: "GST",
    },
    {
      title: "TDS Deducted",
      dataIndex: "TDS_deducted",
      key: "TDS_deducted",
    },
    {
      title: "LAS Margin",
      dataIndex: "Las_Margin",
      key: "LastMargin",
    },
    {
      title: "Total Invoice Value",
      dataIndex: "Total_Invoice_value",
      key: "TotalInvoice_value",
    },
    {
      title: "Exempted",
      dataIndex: "Exempted",
      key: "Exempted",
    },
    {
      title: "Refund",
      dataIndex: "Refund",
      key: "Refund",
    },
    {
      title: "Total Sales",
      dataIndex: "Total_Sales",
      key: "Total_Sales",
    },
    {
      title: "Remarks",
      dataIndex: "Remarks",
      key: "Remarks",
    },
  ];
  // console.log(reportList,'reportList');

  const datas = () => {
    const result =
      reportList &&
      reportList.map((item, index) => {
        return {
          key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
          Invocie_No: item.FBD_invoice_number,
          Invoice_Link: item?.invoiceUrl,
          Supplier_Amount: item.SupplierAmount,
          Taxable_Amount: item.TaxableAmount,
          Name_of_Client: item.client_name,
          GSTIN_No: item.gst_number,
          LastMargin: item.las_Margin,
          CGST: item.CGST,
          Exempted: item.Exepmted,
          IGST: item.IGST,
          Refund: item.Refund,
          Remarks: item.Remark,
          SGST: item.SGST,
          Total_GST: item.TotalGST,
          TotalInvoice_value: item.TotalInvoice,
          Total_Sales: item.Totalsale,
          Agent_Commision: item.agent_commission,
          Total_Sales: item.Totalsale,
          Total_Sales: item.Totalsale,
          Invoice_Date: item.Invoice_date,
          Service_Details: item.Service_Details,
          PNR_NO: item.PNR_NO,
          TDS: item.tds, // Logic added By Sajin (22-11-2024)
          TCS: item.tcs, // Logic added By Sajin (22-11-2024)
          GST: item?.FBPD_oc_gst,
          commisson_from_supplier: item?.FBPD_commission_received_by_supplier,
          TDS_deducted: item?.FBPD_tds_receivable,
        };
      });
    return result;
  };

  // const tableData = useMemo(() => {
  //   if (!reportList) return [];

  //   return reportList.map((item, index) => ({
  //     key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
  //     Invocie_No: item.FBD_invoice_number,
  //     Supplier_Amount: item.SupplierAmount,
  //     Taxable_Amount: item.TaxableAmount,
  //     Name_of_Client: item.client_name,
  //     GSTIN_No: item.gst_number,
  //     LastMargin: item.las_Margin,
  //     CGST: item.CGST,
  //     Exempted: item.Exepmted,
  //     IGST: item.IGST,
  //     Refund: item.Refund,
  //     Remarks: item.Remark,
  //     SGST: item.SGST,
  //     Total_GST: item.TotalGST,
  //     TotalInvoice_value: item.TotalInvoice,
  //     Total_Sales: item.Totalsale,
  //     Agent_Commision: item.agent_commission,
  //     Invoice_Date: item.Invoice_date,
  //     Service_Details: item.Service_Details,
  //     PNR_NO: item.PNR_NO,
  //     TDS: item.tds,
  //     TCS: item.tcs,
  //     GST: item.FBPD_oc_gst,
  //     commisson_from_supplier: item.FBPD_commission_received_by_supplier,
  //     TDS_deducted: item.FBPD_tds_receivable,
  //   }));
  // }, [reportList, pageNumber, totalItemPerPage]);

  // const averages = useMemo(() => {
  //   if (!tableData.length) return null;

  //   const sum = tableData.reduce(
  //     (acc, item) => {
  //       acc.CGST += Number(item.CGST || 0);
  //       acc.SGST += Number(item.SGST || 0);
  //       acc.IGST += Number(item.IGST || 0);
  //       acc.Total_GST += Number(item.Total_GST || 0);
  //       acc.TDS += Number(item.TDS || 0);
  //       acc.TCS += Number(item.TCS || 0);
  //       return acc;
  //     },
  //     { CGST: 0, SGST: 0, IGST: 0, Total_GST: 0, TDS: 0, TCS: 0 }
  //   );

  //   return {
  //     CGST: sum.CGST,
  //     SGST: sum.SGST,
  //     IGST: sum.IGST,
  //     Total_GST: sum.Total_GST,
  //     TDS: sum.TDS,
  //     TCS: sum.TCS,
  //   };
  // }, [tableData]);

  const format = (v) => (v || v === 0 ? Number(v).toFixed(2) : "0.00");

  const avgRow = {
    key: "Total",
    Taxable_Amount: format(totals?.TotalTaxableAmount),
    Supplier_Amount: format(totals?.TotalSupplierAmount),
    CGST: format(totals?.TotalCGST),
    SGST: format(totals?.TotalSGST),
    IGST: format(totals?.TotalIGST),
    Total_GST: format(totals?.TotalGST),
    Total_Invoice_value: format(totals?.TotalInvoice),
    Total_Sales: format(totals?.TotalSales),
    Las_Margin: format(totals?.total_las_margin),
    Refund:format(totals?.TotalRefund)
  };

  const months = [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ];

  //FOR TTITLE WITH EXCEL DOWNLOAD
  const handleExport = async () => {
    try {
      const formData = new FormData();

      Object.entries(filterPayload).forEach(([key, value]) => {
        if (key === "year" && value) {
          const yearValue = value.year
            ? value.year()
            : new Date(value).getFullYear();
          formData.append(key, yearValue);
        } else if (key === "location_id") {
          formData.append(key, value === "All" ? "" : value);
        } else {
          formData.append(key, value);
        }
      });

      const url =
        selectedOption === "B2B"
          ? `/flightBookingReport_B2B`
          : `/flightBookingReport_B2C`;

      const response = await ApiConfig.post(url, formData);

      if (!response?.data?.data?.data) {
        ErrorToast("No data available");
        return;
      }

      const reportList = response.data.data.data;

      // -------------------------------
      // 1) MAP DATA FOR EXCEL
      // -------------------------------
      let result = reportList.map((item) => ({
        "Invoice Date": item.Invoice_date,
        "Invoice No": item.FBD_invoice_number,
        "Name of Client": item.client_name,
        "GSTIN No": item.gst_number,
        "Service Details": item.Service_Details,
        "PNR #": item.PNR_NO,
        "Taxable Amount": item.TaxableAmount,
        [`GST Rate (${taxSettingValues.tax_rate}%)`]: item.Gst_rate || "",
        [`CGST (${taxSettingValues.cgst}%)`]: item.CGST,
        [`SGST (${taxSettingValues.sgst}%)`]: item.SGST,
        [`IGST (${taxSettingValues.igst}%)`]: item.IGST,
        "Total GST": item.TotalGST,
        [`TDS (${taxSettingValues.tds}%)`]: item.tds,
        [`TCS (${taxSettingValues.tcs}%)`]: item.tcs,
        "Supplier Amount": item.SupplierAmount,
        "Agent Commission": item.agent_commission,
        "Commission From Supplier": item.FBPD_commission_received_by_supplier,
        GST: item.FBPD_oc_gst,
        "TDS Deducted": item.FBPD_tds_receivable,
        "LAS Margin": item.las_Margin,
        "Total Invoice Value": item.TotalInvoice,
        Exempted: item.Exepmted,
        Refund: item.Refund,
        "Total Sales": item.Totalsale,
        Remarks: item.Remark,
      }));

      // -------------------------------
      // 2) PUSH TOTAL/AVERAGE ROW
      // -------------------------------

      result.push({
        "Invoice Date": "", // will be merged
        "Invoice No": "",
        "Name of Client": "",
        "GSTIN No": "",
        "Service Details": "",
        "PNR #": "",
        "Taxable Amount": totals?.TotalTaxableAmount,
        [`GST Rate (${taxSettingValues.tax_rate}%)`]: "",
        [`CGST (${taxSettingValues.cgst}%)`]: totals?.TotalCGST,
        [`SGST (${taxSettingValues.sgst}%)`]: totals?.TotalSGST,
        [`IGST (${taxSettingValues.igst}%)`]: totals?.TotalIGST,
        "Total GST": totals?.TotalGST,
        [`TDS (${taxSettingValues.tds}%)`]: "",
        [`TCS (${taxSettingValues.tcs}%)`]: "",
        "Supplier Amount": totals?.TotalSupplierAmount,
        "Agent Commission": "",
        "Commission From Supplier": "",
        GST: "",
        "TDS Deducted": "",
        "LAS Margin": totals?.total_las_margin,
        "Total Invoice Value": totals?.TotalInvoice,
        Exempted: "",
        Refund: totals?.TotalRefund,
        "Total Sales": totals?.TotalSales,
        // Remarks: "AVERAGE",
      });

      // -------------------------------
      // 3) TITLE GENERATION
      // -------------------------------
      const monthLabel =
        months.find((m) => m.value === filterPayload.month)?.label ||
        "AllMonths";

      const locationLabel =
        locations?.find((loc) => loc.value === filterPayload.location_id)
          ?.label || "AllLocations";

      const marginText = `Total Margin: ${
        selectedOption === "B2B"
          ? response?.data?.total_las_margin
          : response?.data?.total || 0
      }`;

      let title = "";
      if (isFinancialYear) {
        title = `${selectedOption} Report (${filterPayload.financial_year_start} - ${filterPayload.financial_year_end})`;
      } else if (filterPayload.month) {
        title = `${selectedOption} Report - ${monthLabel} - ${locationLabel} - ${new Date(
          filterPayload.year
        ).getFullYear()}`;
      } else {
        title = `${selectedOption} Report - ${new Date(
          filterPayload.year
        ).getFullYear()} - ${locationLabel}`;
      }

      // -------------------------------
      // 4) CREATE WORKBOOK
      // -------------------------------
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(result, { origin: "A3" });

      // Insert title and margin text
      XLSX.utils.sheet_add_aoa(worksheet, [[title], [marginText]], {
        origin: "A1",
      });

      const columnCount = Object.keys(result[0]).length;

      // -------------------------------
      // MERGE TITLE
      // -------------------------------
      worksheet["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } },
      ];

      // -------------------------------
      // MERGE TOTAL ROW (A → G)
      // -------------------------------
      const totalRowIndex = result.length + 2; // starts at row 3 (+2)

      worksheet["!merges"].push({
        s: { r: totalRowIndex, c: 0 },
        e: { r: totalRowIndex, c: 6 },
      });

      const totalCellRef = XLSX.utils.encode_cell({ r: totalRowIndex, c: 0 });
      worksheet[totalCellRef] = { v: "Total", t: "s" };

      // -------------------------------
      // COLUMN WIDTH / SPACING
      // -------------------------------
      worksheet["!cols"] = Array(columnCount).fill({ wch: 28 });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      const currentDate = new Date()
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-");

      const fileName = `${selectedOption}_Report_${monthLabel}_${locationLabel}_${currentDate}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      ErrorToast("An error occurred during Excel export");
    }
  };

  const handleChangeOption = (value) => {
    setSelectedOption(value);
    setPageNumber(1);
  };

  const handleFilterChange = (key, value) => {
    setFilterPayload((prev) => ({ ...prev, [key]: value }));
  };

  const handleToggleFinancialYear = (event) => {
    const checked = event.target.checked;
    setIsFinancialYear(checked);
    handleFilterChange("filter_type", checked ? "FINANCIAL" : "YEAR");
  };

  const isMobile = useMediaQuery("(max-width: 1220px)");
  return (
    <div
      className="sales_report_main_container"
      style={{
        maxWidth: isMobile
          ? "100vw"
          : !isCollapsed
          ? `calc(100vw - 350px)`
          : `calc(100vw - 175px)`,
      }}
    >
      <div className="sales_report_header">
        <p className="sales_report_title">
          {isFinancialYear
            ? `${selectedOption} Report(${filterPayload?.financial_year_start} - ${filterPayload?.financial_year_end})`
            : filterPayload.month
            ? `${selectedOption} Report for the month of ${
                months.find((item) => item.value === filterPayload.month)?.label
              } in the year ${new Date(filterPayload.year).getFullYear()} `
            : `${selectedOption} Report for the year ${new Date(
                filterPayload.year
              ).getFullYear()} `}
        </p>
      </div>
      {/* ---------- FILTERS ---------- */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "14% 14% 14% 14% 14% 14% auto",
          alignItems: "center",
          gap: 2,
          marginY: 2,
        }}
      >
        {/* Sales Type */}
        <FormControl>
          <CustomAutoCompleteDropdown
            allowClear={false}
            readOnly={true}
            options={[
              { value: "B2B", label: "B2B Sales" },
              { value: "B2C", label: "B2C Sales" },
            ]}
            onChange={(e, newValue) => handleChangeOption(newValue?.value)}
            value={
              [
                { value: "B2B", label: "B2B Sales" },
                { value: "B2C", label: "B2C Sales" },
              ].find((opt) => opt.value === selectedOption) || null
            }
          />
        </FormControl>

        {/* Location */}
        <FormControl>
          <CustomAutoCompleteDropdown
            allowClear={false}
            options={locations}
            readOnly={true}
            onChange={(e, newValue) =>
              handleFilterChange("location_id", newValue?.value)
            }
            value={
              locations.find(
                (loc) => loc.value === filterPayload.location_id
              ) || null
            }
          />
        </FormControl>

        {/* Service */}
        <FormControl>
          <CustomAutoCompleteDropdown
            allowClear={false}
            options={servicesList}
            readOnly={true}
            onChange={(e, newValue) =>
              handleFilterChange("service_id", newValue?.value)
            }
            value={
              servicesList.find(
                (srv) => srv.value === filterPayload.service_id
              ) || null
            }
          />
        </FormControl>

        {/* Conditional Filters */}
        {!isFinancialYear ? (
          <>
            <FormControl>
              <CustomAutoCompleteDropdown
                allowClear={false}
                readOnly={true}
                options={[{ label: "All", value: "" }, ...months]} // ✅ use spread instead of push
                onChange={(e, newValue) =>
                  handleFilterChange("month", newValue?.value)
                }
                value={
                  [{ label: "All", value: "" }, ...months].find(
                    (m) => m.value === filterPayload.month
                  ) || null
                }
              />
            </FormControl>

            <FormControl>
              <CustomYearPicker
                readOnly={true}
                views={["year"]}
                maxDate={dayjs().endOf("year")}
                value={filterPayload.year}
                onChange={(year) => handleFilterChange("year", year)}
              />
            </FormControl>
          </>
        ) : (
          <FormControl>
            <CustomAutoCompleteDropdown
              allowClear={false}
              readOnly={true}
              options={financialYearOptions}
              onChange={(e, newValue) => {
                handleFilterChange(
                  "financial_year_start",
                  newValue?.value.start
                );
                handleFilterChange("financial_year_end", newValue?.value.end);
              }}
              value={
                financialYearOptions.find(
                  (fy) =>
                    fy.value.start === filterPayload.financial_year_start &&
                    fy.value.end === filterPayload.financial_year_end
                ) || null
              }
            />
          </FormControl>
        )}

        {/* Financial Year Toggle */}
        <FormControl>
          <div className="sales_report_financial_year_toggle_container">
            <Switch
              checked={isFinancialYear}
              onChange={handleToggleFinancialYear}
            />
            <p>Financial Year</p>
          </div>
        </FormControl>

        {/* Excel Download */}
        {isSales_Download && (
          <IconButton
            onClick={() => {
              handleExport();
            }}
          >
            <PiMicrosoftExcelLogoLight className="sales_excel_icon" />
          </IconButton>
        )}
      </Box>

      {/* ---------- TABLE ---------- */}

      <CustomTable
        columns={selectedOption === "B2B" ? Columns : Columns_B2C}
        rows={datas()}
        loading={isLoading}
        avgRow={avgRow}
      />

      <CustomBottomPagination
        pageFrom="sales_report"
        total_items_per_page={totalItemPerPage}
        total_page_count={totalPages}
        current_page={pageNumber}
        on_change_value={setPageNumber}
        on_page_count_update={setTotalItemPerPage}
      />

      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "8px 16px",
          fontWeight: "600",
          fontSize: "16px",
          color: "#333",
          marginTop: 10,
        }}
      >
        <p style={{ margin: 0 }}>Total Margin: {totals?.total_las_margin}</p>
      </div> */}
    </div>
  );
};

export default SalesReports;
